export function scrollReaderToPage(page: number, behavior: ScrollBehavior = 'auto') {
  const container = document.querySelector<HTMLElement>('.viewer-scroll');
  const target = container?.querySelector<HTMLElement>(`[data-page="${page}"]`);
  if (!container || !target) return false;
  const top = target.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop;
  container.scrollTo({ top: Math.max(0, top), behavior });
  return true;
}

export function scrollReaderToPageAfterLayout(page: number) {
  requestAnimationFrame(() => requestAnimationFrame(() => scrollReaderToPage(page)));
}
